import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PendingHeartRunnerListComponent from '../components/pendingHeartRunnerComponent';
import {  logOutAdmin } from '../../../SuperAdminLogin/actions/superAdminLoginAction'
import { fetchHeartRunnerDetail,approveHeartRunner,rejectHeartRunner,getAllRegionSettings }
     from '../actions/pendingHeartRunnerListAction';


class PendingHeartRunnerListContainer extends Component {
   
    componentWillMount() {
        /* this.props.actions.fetchHeartRunnerDetail(            
            this.props.dispatch
        ) */
         this.props.actions.getAllRegionSettings();
    }
    getPendingList = () =>{
        this.props.actions.fetchHeartRunnerDetail(            
            this.props.dispatch
        )
    }
    getUserList = (data) =>{
                this.props.actions.fetchHeartRunnerDetail(data,
                    this.props.dispatch
                )
            }
    onApprove=(SelectedRow,Region)=> {
        
        this.props.actions.approveHeartRunner(
            this.props.heartRunnerList.isLoading,
            SelectedRow,Region,
            this.props.dispatch)
    }
    onReject=(SelectedRow,Region)=>{
        debugger
        this.props.actions.rejectHeartRunner(
            this.props.heartRunnerList.isLoading,
            SelectedRow,Region,
            this.props.dispatch)
    }
    // onApproveReject(SelectedRow) {
    //     this.props.actions.updateOrganisationDetailRequest(
    //         this.props.organisationList.isLoading,
    //         SelectedRow,
    //         this.props.dispatch)
    // }

   getRegionData = () => {
                 this.props.actions.getAllRegionSettings(this.props.dispatch);
              } 

    render() {
        return (
            <div className="agile-grids">
                <div className="grids">
                    <div className="container">
                        <div className="row">
                            <PendingHeartRunnerListComponent 
                                heartRunnerList={this.props.heartRunnerList}
                                onApprove={this.onApprove} 
                                onReject={this.onReject} 
                                getPendingList = {this.getPendingList}
                                getRegionList={this.getRegionData}
                    getUserList ={this.getUserList}                          
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
           logOutAdmin, 
           fetchHeartRunnerDetail,
           approveHeartRunner,
           rejectHeartRunner,
           getAllRegionSettings,
        }, dispatch)
    };
};

function mapStateToProps({ pendingHeartRunnerReducer, superAdminLoginReducer }) {
    console.log(pendingHeartRunnerReducer)
    return {
        heartRunnerList: {
            isLoading: pendingHeartRunnerReducer.isLoading,
            pendingHeartRunnerList: pendingHeartRunnerReducer.pendingHeartRunnerList,
            errorNumber: pendingHeartRunnerReducer.errorNumber,
            errorMessage: pendingHeartRunnerReducer.errorMessage,
            messageLabel: pendingHeartRunnerReducer.messageLabel,
            regionList : pendingHeartRunnerReducer.regionList,
            statusCode:pendingHeartRunnerReducer.statusCode,
        },
        login: {
            authTokenId: superAdminLoginReducer.authTokenId,
            adminId: superAdminLoginReducer.userId
        }
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PendingHeartRunnerListContainer))